import { IAuthRepository, UserDetailsResponse } from "@/core/repositories/auth";
import { createLogger, ILogger } from "@/infrastructure/services/logger";

type GetUserDetailsResult = { type: "success"; userDetails: UserDetailsResponse } | { type: "error"; errorMessage: string };

export class GetUserDetailsUseCase {
  private readonly logger: ILogger = createLogger("GetUserDetailsUseCase");
  
  constructor(private readonly authRepository: IAuthRepository) { }

  async execute(brandKey?: string): Promise<GetUserDetailsResult> {
    try {
      const userDetails = await this.authRepository.getUserDetails(brandKey);
      await this.authRepository.saveUserToStorage(userDetails);
      this.logger.info("User details fetched", {
        email: userDetails.userProps.email,
        name: userDetails.userProps.firstName + " " + userDetails.userProps.lastName,
      });
      return {
        type: "success",
        userDetails: userDetails,
      };
    } catch (error: any) {
      this.logger.error(error?.message ?? "Error fetching user details", error);
      return {
        type: "error",
        errorMessage: "There was a problem processing your request. Please try again, or contact support if the issue persists",
      };
    }
  }
}
